// extracted by mini-css-extract-plugin
export default {"container":"ModuleExercises_container__u6cnc","exercises":"ModuleExercises_exercises__EaB3z"};